import Vue from 'vue'
import VueCookies from 'vue-cookies'

// Promises must be loaded for webpack's import to work. So this must remain globally
import '@/utilities/polyfills/promise'
import '@/utilities/featuredetection'
import polyfillInit from '@/utilities/polyfills'
import Bootstrap from '@/Bootstrap'
import router from '@/router'
import store from '@/store'
import MomentFilters from '@/filters/MomentFilters'
import PricingFilters from '@/filters/PricingFilters'
import PassengerFilters from '@/filters/PassengerFilters'
import ClickOutsideDirective from '@/directives/ClickOutsideDirective'
import MainComponents from '@/plugins/mainComponents'
import ErrorHandler from '@/plugins/errorhandler'
import Analytics from '@/plugins/analytics'
import VueAnnouncer from '@vue-a11y/announcer'
import i18nInit, { i18nInstance } from '@/i18n'
import VueCountryCode from 'vue-country-code'

Vue.config.productionTip = false

Vue.use(MomentFilters)
Vue.use(PricingFilters)
Vue.use(PassengerFilters)
Vue.use(ClickOutsideDirective)
Vue.use(MainComponents)
Vue.use(ErrorHandler)
Vue.use(Analytics)
Vue.use(VueCookies)
Vue.use(VueAnnouncer, { complementRoute: '' }, router)
Vue.use(VueCountryCode)

const i18n = i18nInstance()

Promise.all([polyfillInit(), i18nInit()]).then(() => {
	/* eslint-disable no-new */
	new Vue({
		el: '#app',
		i18n,
		router,
		store,
		render: h => h(Bootstrap)
	})
})
